import React, {useState} from 'react';
import {Formik} from 'formik';
import {withStyles} from '@material-ui/core/styles';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import FormGrid from '../../../components/Form/FormGrid';
import {Title2, Body, Caption1} from '../../../components/Typography';
import {PrimaryButton, ButtonRow} from '../../../components/Buttons';
import Headline from '../../../components/Typography/Headline';
import Dialog from '@material-ui/core/Dialog';

const Wrapper = styled.div`
  display: grid;
  grid-gap: 20px;
`;

const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
`;

const Cancel = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: white;
  background-color: rgba(81, 78, 89, 0.63);
  right: 8px;
  top: 8px;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  &:hover {
    background: ${props => props.theme.closeButtonHoverColor};
    transition: all 0.25s ease;
  }
`;

const ForgotPassword = styled(Caption1)`
  color: ${props => props.theme.clickableTextColor};
  cursor: pointer;
  margin-right: auto;
  &:hover {
    text-decoration: underline;
    color: ${props => props.theme.clickableTextColorHover};
    transition: all 0.25s ease;
  }
`;
const ForgotPasswordWrapper = styled.div`
  width: 400px;
  padding: 20px;
  background: white;
  margin: auto;
  display: grid;
  grid-gap: 20px;

  @media (max-width: 786px) {
    padding: 24px 20px;
    width: 100%;
  }
`;

const styles = theme => ({
  input: {
    fontFamily: theme.typography.fontFamily.main,
  },
});

const LoginForm = ({
  isRequesting,
  login,
  hideAuthenticationModal,
  classes,
  checkedEmail,
  handleSubmitForgotPassword,
  forgotPasswordSuccess,
  resetForgotPassword,
}) => {
  const [forgotEmailModalIsVisible, setForgotEmailModalIsVisible] = useState(
    false
  );
  const [disableEmailField, setDisableEmailField] = useState(false);
  const [errorText, setErrorText] = useState('');

  if (forgotPasswordSuccess) {
    setTimeout(() => {
      setForgotEmailModalIsVisible(false);
      resetForgotPassword();
      setDisableEmailField(false);
    }, 3000);
  }

  return (
    <Wrapper>
      <TitleWrapper>
        <Title2 id="LoginForm-Title">LOGIN</Title2>
        <Cancel id="LoginForm-CancelButton" onClick={hideAuthenticationModal}>
          <i className="fal fa-times" />
        </Cancel>
      </TitleWrapper>
      <Body id="LoginForm-Message">
        Looks like you have an account!
        <br />
        Please enter your password to view our menu
      </Body>
      <Formik
        initialValues={{password: ''}}
        validate={values => {
          let errors = {};
          if (!values.password) {
            errors.password = 'Required';
          }
          return errors;
        }}
        onSubmit={login}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit}>
            <FormGrid style={{gridGap: '20px'}}>
              <TextField
                id="LoginForm-Password"
                label="Password"
                name="password"
                type="password"
                autoComplete="current-password"
                value={values.password}
                onChange={handleChange}
                required
                onBlur={handleBlur}
                error={touched.password && errors.password ? true : false}
                helperText={touched.password && errors.password}
                InputLabelProps={{
                  className: classes.input,
                  required: false,
                }}
              />
              <ForgotPassword
                id="LoginForm-ForgotPassword"
                onClick={() => setForgotEmailModalIsVisible(true)}
              >
                Forgot Password?
              </ForgotPassword>
              <ButtonRow justifyContent="center">
                <PrimaryButton
                  id="LoginForm-LoginButton"
                  type="submit"
                  disabled={isRequesting}
                >
                  Login
                </PrimaryButton>
              </ButtonRow>
            </FormGrid>
          </form>
        )}
      </Formik>
      <Dialog
        id="LoginForm-Dialog"
        aria-labelledby="forgot-password"
        aria-describedby="forgot-password"
        open={forgotEmailModalIsVisible}
        onBackdropClick={() => setForgotEmailModalIsVisible(false)}
        fullWidth={typeof window !== 'undefined' && window.innerWidth < 786}
        fullScreen={typeof window !== 'undefined' && window.innerWidth < 786}
        classes={{scrollPaper: classes.scrollPaper}}
        PaperProps={{classes: {root: classes.paper}}}
        scroll="body"
      >
        <ForgotPasswordWrapper>
          <TitleWrapper>
            <Headline id="LoginForm-ForgotPassword-Title">
              FORGOT PASSWORD
            </Headline>
            <Cancel
              id="LoginForm-ForgotPassword-Cancel"
              onClick={() => setForgotEmailModalIsVisible(false)}
            >
              <i className="fal fa-times" />
            </Cancel>
          </TitleWrapper>
          <Body id="LoginForm-ForgotPassword-Message">
            We will send you an email with a password recovery link
          </Body>
          <TextField
            id="LoginForm-ForgotPassword-Email"
            label="Email"
            name="email"
            type="email"
            autoComplete="username"
            value={checkedEmail}
            disabled={disableEmailField}
            // onChange={e => {
            //   handleForgotPaddwordEmailChange(e.target.value);
            //   setForgotPasswordEmail(e.target.value);
            // }}
            required
            helperText={errorText}
            error={errorText.length ? true : false}
            InputLabelProps={{
              className: classes.input,
              required: false,
            }}
          />
          {forgotPasswordSuccess && (
            <Caption1>Password recovery link sent!</Caption1>
          )}
          <ButtonRow justifyContent="center">
            <PrimaryButton
              id="LoginForm-ForgotPassword-Submit"
              disabled={!checkedEmail || errorText.length}
              onClick={() => {
                setDisableEmailField(true);
                handleSubmitForgotPassword(checkedEmail);
              }}
            >
              SUBMIT
            </PrimaryButton>
          </ButtonRow>
        </ForgotPasswordWrapper>
      </Dialog>
    </Wrapper>
  );
};

export default withStyles(styles)(LoginForm);
